import React from 'react';
import { Typography } from '@mui/material';

function MyStudySidekick({ className = '', component, id }) {
  const classes = ['mss__stylizedText', className].filter(Boolean).join(' ');
  return (
    <Typography id={id} variant="h3" component={component} className={classes}>
      <span id={id ? `${id}__text_myStudy` : undefined}>myStudy</span>
      <span id={id ? `${id}__text_sidekick` : undefined}>Sidekick</span>
    </Typography>
  );
}

export default MyStudySidekick;
